import { IconButton, Tooltip } from '@mui/material'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CheckIcon from '@mui/icons-material/Check'
import CrossIcon from '@mui/icons-material/Close'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import EditIcon from '@mui/icons-material/Edit'

import EnhancedTable from '../../ui/EnhancedTable'
import { useGetUsers, useGetUsersInfinite } from '../../../hooks/api/users'
import { useNavigate, Link } from 'react-router-dom'
import { format, parseISO } from 'date-fns'
import InfiniteList from '../../ui/InfiniteList'
import UserView from './UserView'
import dealershipBrandsDict from '../../../constants/dealershipBrands'

const checkIcon = (
  <Tooltip title='Yes'>
    <CheckIcon color='success' />
  </Tooltip>
)
const crossIcon = (
  <Tooltip title='No'>
    <CrossIcon color='error' />
  </Tooltip>
)

const headCells = (props) => [
  {
    id: '_id',
    numeric: false,
    sortable: false,
    disablePadding: false,
    label: 'ID',
  },
  {
    id: 'email',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Email',
  },
  {
    id: 'dealershipBrand',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Brand',
    view: (data) =>
      data.dealershipBrand && (dealershipBrandsDict[data.dealershipBrand] || data.dealershipBrand),
  },
  {
    id: 'dealershipName',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Dealership Name',
  },
  {
    id: 'isHTAStaff',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'HTA Staff?',
    view: (data) => (data.isHTAStaff ? checkIcon : crossIcon),
  },
  {
    id: 'isAdmin',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Admin?',
    view: (data) => (data.isAdmin ? checkIcon : crossIcon),
  },
  {
    id: 'isActive',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Active?',
    view: (data) => (data.isActive ? checkIcon : crossIcon),
  },
  {
    id: 'createdAt',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Created at',
    view: (data) => {
      try {
        return format(parseISO(data.createdAt), 'dd/MM/yyyy')
      } catch (err) {
        console.error(err)
      }
      return ''
    },
  },
  {
    id: 'updatedAt',
    numeric: false,
    sortable: true,
    disablePadding: true,
    label: 'Updated at',
    view: (data) => {
      try {
        return format(parseISO(data.updatedAt), 'dd/MM/yyyy')
      } catch (err) {
        console.error(err)
      }
      return ''
    },
  },
  {
    id: 'edit',
    numeric: true,
    sortable: false,
    disablePadding: false,
    label: '',
    view: (data) => (
      <Tooltip title='Edit'>
        <IconButton LinkComponent={Link} to={`/admin/users/edit/${data.id}`}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    ),
  },
]

export function UsersTable() {
  const navigate = useNavigate()

  return (
    <InfiniteList
      component={UserView}
      useInfiniteQuery={useGetUsersInfinite}
      headCells={headCells()}
      onNew={() => navigate('/admin/users/create')}
      newIcon={<PersonAddIcon />}
      newLabel='New user'
    />
  )
}
